import { classes } from 'html-classes';

import {
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '~/components/ModalComponents';

import styles from './Skeleton.module.scss';

interface SkeletonProps {
  className?: string;
}

const Skeleton = ({ className }: SkeletonProps) => {
  return <div className={classes([styles.skeleton, className])} />;
};

interface SkeletonModalProductProps {
  onClose: () => void;
}

const SkeletonModalProduct = ({ onClose }: SkeletonModalProductProps) => {
  return (
    <>
      <ModalHeader onClose={onClose} className={styles.header}>
        <Skeleton className={styles.header_skeleton} />
      </ModalHeader>
      <ModalBody className={styles.body}>
        <div className={styles.body__image_container}>
          <Skeleton className={styles.body__image_container__image_skeleton} />
          <div className={styles.body__image_container__sub_image}>
            {new Array(4).fill(0).map((_, index) => (
              <Skeleton
                key={index}
                className={styles.body__image_container__sub_image__skeleton}
              />
            ))}
          </div>
        </div>

        <div className={styles.body__content_container}>
          <div className={styles.body__content_container__volumes}>
            {new Array(5).fill(0).map((_, index) => (
              <Skeleton
                key={index}
                className={styles.body__content_container__volumes__item}
              />
            ))}
          </div>
          <div className={styles.body__content_container__description}>
            <Skeleton
              className={styles.body__content_container__description__title}
            />
            {new Array(8).fill(0).map((_, index) => (
              <Skeleton
                key={index}
                className={styles.body__content_container__description__row}
              />
            ))}
            <Skeleton
              className={styles.body__content_container__description__showmore}
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter className={styles.footer}>
        <Skeleton className={styles.footer__skeleton_cost} />
        <Skeleton className={styles.footer__skeleton_button} />
      </ModalFooter>
    </>
  );
};

export default SkeletonModalProduct;
